import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: 'header-content',
  standalone: true
})
export class MoviesCarouselHeaderContentDirective {
  constructor(public template: TemplateRef<unknown>) {}
}

@Directive({
  selector: 'footer-content',
  standalone: true
})
export class MoviesCarouselFooterContentDirective {}

@Directive({
  selector: 'left-content',
  standalone: true
})
export class MoviesCarouselLeftContentDirective {}

@Directive({
  selector: 'right-content',
  standalone: true
})
export class MoviesCarouselRightContentDirective {}
